import { upsertBulkCategoriesRequest } from 'actions';
import { GlobalState } from 'reducers';
import { createSelector } from 'reselect';
import type { Category, Customer, Model, RuleRevision, Selector, UUID } from 'types';

export const getUpsertBulkCategoriesLoading: Selector<boolean> = (state) =>
  state.bulkOutcomes.loading.includes(upsertBulkCategoriesRequest.toString()) || false;

export const getSelectedCustomerOutcomes: Selector<Customer | null> = (state) =>
  state.bulkOutcomes.customer;

export const getSelectedUseCaseOutcomes: Selector<Model | null> = (state) =>
  state.bulkOutcomes.useCase;

export const getRuleBulkOutcomes: Selector<
  { rule: RuleRevision; categories: Category[] },
  [UUID]
> = (state, id) => state.bulkOutcomes.rules[id];

export const getRulesBulkOutcomes: Selector<{ rule: RuleRevision; categories: Category[] }[]> =
  createSelector(
    [
      (
        state: GlobalState
      ): Record<
        string,
        {
          rule: RuleRevision;
          categories: Category[];
        }
      > => state.bulkOutcomes.rules,
    ],
    (rules) => Object.values(rules)
  );

export const getCategoriesByRuleBulkOutcomes: Selector<Category[], [UUID]> = createSelector(
  [
    (
      state: GlobalState
    ): Record<
      string,
      {
        rule: RuleRevision;
        categories: Category[];
      }
    > => state.bulkOutcomes.rules,
    (_state: GlobalState, ruleId: UUID): UUID => ruleId,
  ],
  (rules, ruleId) => rules[ruleId].categories
);

export const getRuleCategoriesBulkOutcomes: Selector<
  Record<
    string,
    {
      rule: RuleRevision;
      categories: Category[];
    }
  >
> = createSelector(
  [
    (
      state: GlobalState
    ): Record<
      string,
      {
        rule: RuleRevision;
        categories: Category[];
      }
    > => state.bulkOutcomes.rules,
  ],
  (rules) => rules
);
